const TrackingDetails = ({ data }) => {
    return (
        <table className="table">
            <thead>
                <tr>
                    <th style={{ position: 'sticky', top: 0, backgroundColor: '#e25a0c', color: 'white' }}>Transaction Time</th>
                    <th style={{ position: 'sticky', top: 0, backgroundColor: '#e25a0c', color: 'white' }}>Event</th>
                    <th style={{ position: 'sticky', top: 0, backgroundColor: '#e25a0c', color: 'white' }}>Location</th>
                    <th style={{ position: 'sticky', top: 0, backgroundColor: '#e25a0c', color: 'white' }}>Message</th>
                </tr>
                {
                    data.map((x, index) =>
                        <tr key={index}>
                            <td>{x.dateTime}</td>
                            <td>{x.status}</td>
                            <td>{x.location}</td>
                            <td>{x.detail}</td>
                        </tr>
                    )
                }
            </thead>
        </table>
    )
}

export default TrackingDetails;